import { render, staticRenderFns } from "./ConfigurazioniComponent.vue?vue&type=template&id=a05c84ee"
import script from "./ConfigurazioniComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazioniComponent.vue?vue&type=style&index=0&id=a05c84ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports